<template>
    <div class="login-form-wrapper p-4">
        <h3 class="mb-4">{{ translations.login }}</h3>
        
        <div v-if="error" class="alert alert-danger mb-3">
            {{ translations.loginError }}
        </div>

        <form @submit.prevent="handleLogin">
            <FormulateInput
                type="email"
                v-model="email"
                :label="translations.emailAddress"
                validation="required|email"
                :required="true"
                class="mb-3"
            ></FormulateInput>

            <FormulateInput
                type="password"
                v-model="password"
                :label="translations.password"
                validation="required"
                :required="true"
                class="mb-4"
            ></FormulateInput>

            <button 
                type="submit" 
                class="btn-primary w-100"
                :disabled="loading"
            >
                <span v-if="loading">{{ translations.loading }}...</span>
                <span v-else>{{ translations.loginSubmit }}</span>
            </button>
        </form>
    </div>
</template>

<script>
import translations from '../../mixins/translations';

export default {
    name: 'LoginForm',
    mixins: [translations],
    data() {
        return {
            email: '',
            password: '',
            loading: false,
            error: false,
        };
    },
    methods: {
        handleLogin() {
            this.loading = true;
            this.error = false;

            window.axios.post('/user/login?_format=json', {
                name: this.email,
                pass: this.password
            })
            .then(response => {
                // Fetch user data after successful login
                console.log('Login successful, fetching user data...');
                return window.axios.get('/api/customer/mendix-user-data');
            })
            .then(response => {
                const userData = response.data;
                
                // Map API data to our form fields
                const formData = {
                    title: userData.Titel?.toLowerCase() || '',
                    first_name: userData.Voornaam || '',
                    last_name: userData.Achternaam || '',
                    street: userData.Straat || '',
                    house_number: userData.Huisnummer || '',
                    postal_code: userData.Postcode || '',
                    city: userData.Stad || '',
                    email: userData.Email || this.email,
                    phone_number: userData.Telefoon || '',
                };

                console.log('User data:', formData);

                this.$store.commit('SET_FORM_DATA', formData);
                this.$store.commit('SET_IS_LOGGED_IN', true);
                
                // Set uid in drupalSettings to reflect logged in state in StepThree
                if (typeof drupalSettings !== 'undefined') {
                    if (!drupalSettings.user) drupalSettings.user = {};
                    drupalSettings.user.uid = 1; // Any non-zero value to indicate logged in
                }

                this.loading = false;
                
                this.$emit('logged-in');
            })
            .catch(error => {
                console.error('Login error:', error);
                this.error = true;
                this.loading = false;
            });
        }
    }
};
</script>

<style scoped>
.login-form-wrapper {
    max-width: 400px;
    margin: 0 auto;
}
</style>
